/**
 * 微前端之间交互通道
 */
export class HubService {
    constructor(message, authentication) {
        this.serviceBus = message;
        this.authentication = authentication;
        this.window = window;
        this.header = {};
    }
}
